<template>
    
<div>

    <page-padding>
     
        <spinner v-if="showLoader && !hasNewletters" class="spinner-custom" />
        <div v-if="!showLoader && !hasNewletters">{{$t('language.no_newsletters')}}</div>
        <div v-if="hasNewletters">
         
          <div>
            <featured-button :key="index" v-for='(item,index) in sliceArray(newsletters["0newsletters"],3)' iconRight="file-download" :title="item.title" :subtitle="item.descr" @click.native="viewPdf(item)"/>  
          </div>
          <button-more title="language.view_more_newsletters" to="/newsletters"/>
        </div>
      </page-padding>

</div>
</template>

<script>

import { mapState } from 'vuex';
import PagePadding from '../../components/PagePadding';
import Spinner from '../../components/Spinner';
import ButtonMore from '../../components/buttons/ButtonMore';
import FeaturedButton from '../../components/buttons/FeaturedButton.vue';

import { fileSave } from '../../services/FileSave.js';

export default {
  name: 'list-newsletters-featured',
  props:{
  },
  data:function(){
    return {
      showLoader:false
    }
  },
  components:{
    PagePadding,
    Spinner,
    ButtonMore,
    FeaturedButton,
  },
  methods:{
    viewPdf(media){
      
      var fileName=media.title;
      // why the title has no .pdf attached here?
      if(!media.title.includes(".pdf")){
        fileName+=".pdf";
      }
      
      this.$store.dispatch('get_crossdomain_download',{newsl_id:media.id,fileName:media.filename}).then(
        result=>{
          var base64data= "data:application/pdf;base64,"+result.data.base64Data;
          fileSave.saveBase64ToFile(base64data, fileName);
      })
      
    },
    sliceArray(arr,count){
      if(arr){
        return arr.slice(0,count)
      }else{
        return [];
      }
    }
  },
  computed:{
    ...mapState([
       'newsletters',
       ]),
       hasNewletters:function(){
         if(this.newsletters["0newsletters"]){
           return this.newsletters["0newsletters"] ? this.newsletters["0newsletters"].length :0;
         }else{
           return false;
         }
       }
  },
  created:function(){

    this.showLoader=true;
    this.$store.dispatch('get_newsletters',{store_key:"0newsletters",id:0}).then(()=>{
      this.showLoader=false;
    })
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.heading{
  background-color:#EEEEEE;
  padding:5px;
  margin-bottom:15px;
  border-radius:4px;
}
.calendar-item{
  margin-bottom:25px;
}
.spinner-custom{
  margin:10px 0;
}
</style>

